import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const PublicRoute = ({ children }) => {
  const authToken = localStorage.getItem("twinbox-admin-store");
  const user = JSON.parse(authToken);
  const navigate = useNavigate();
  // If the user is authenticated, redirect to a protected page
  if (user?.token) {
    navigate("/dashboard");
    window.location.href = process.env.REACT_APP_HOME_PAGE + "dashboard";
  }
  // If not authenticated, allow access to the public page (e.g., login)
  return children;
};
export default PublicRoute;
